import { tbColors, tbPalette } from 'styles/colors';

const chartColors = {
  TENANT: tbPalette.data.vis.default,
  PEER: tbColors.brand.darkBlue[600],
  COMPARISON: tbPalette.data.vis.comparison,
  multiChart: [
    tbColors.brand.turquoise[600],
    tbColors.brand.coral[500],
    tbColors.brand.biscuit[500],
    tbColors.brand.darkBlue[600],
    tbColors.brand.orange[500],
    tbColors.brand.olive[600],
    tbColors.brand.turquoise[300],
    tbColors.brand.coral[200],
    tbColors.brand.petrol[600],
    tbColors.brand.orange[300],
    tbColors.brand.eucalyptus[500],
    tbColors.brand.turquoise[900],
    tbColors.brand.biscuit[50],
    tbColors.brand.petrol[800],
    tbColors.brand.biscuit[800],
  ],
};

export { chartColors };
